export default "__VITE_ASSET__ad563011__"